// extracted by mini-css-extract-plugin
export default {"container":"Emoticon_container__aXQKb","div1":"Emoticon_div1__wVAj8"};